var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.83 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.59.64v12.07l4.15-4.46a.62.62 0 0 1 .87 0 .69.69 0 0 1 0 .94L6.42 14.8a.6.6 0 0 1-.86 0L.19 9.18a.7.7 0 0 1 0-.95.6.6 0 0 1 .86 0l4.27 4.47V.64a.64.64 0 1 1 1.27 0",
    className: "arrow-down_svg__a"
  })));
};
export default SvgArrowDown;